import type { GraphicFamily } from "../../api/types";

/** Pictogramme d'un type de graphique (palette, liste, fiche). En symbologie OTAN, la couleur dit le camp (bleu
 *  ami, jaune NRBC), pas le type : la forme distingue donc les familles — cercle d'une zone, trait d'une ligne,
 *  flèche de l'axe d'effort, secteur sous le vent d'un panache NRBC. Le jaune reçoit un liseré sombre pour se
 *  lire sur fond clair. */
export function GraphicGlyph({
  family,
  kind,
  color,
  size = 14,
}: {
  family: GraphicFamily;
  kind: string;
  color: string;
  size?: number;
}) {
  const light = family === "cbrnPlumes";
  const casing = light ? { stroke: "rgb(0 0 0 / 0.45)", strokeWidth: 3.25 } : null;
  return (
    <svg width={size} height={size} viewBox="0 0 14 14" className="shrink-0" aria-hidden="true">
      {family === "operationalGraphics" && (
        <circle cx="7" cy="7" r="5.25" fill={color} fillOpacity={0.18} stroke={color} strokeWidth={1.75} />
      )}
      {family === "lineGraphics" && (
        <g fill="none" stroke={color} strokeWidth={2} strokeLinecap="round" strokeLinejoin="round">
          <line x1="2" y1="12" x2="12" y2="2" />
          {kind === "axisOfAdvance" && <polyline points="6.5,2 12,2 12,7.5" />}
        </g>
      )}
      {family === "cbrnPlumes" && (
        <g strokeLinejoin="round">
          {casing && <path d="M3 7 L13 2 A 11 11 0 0 1 13 12 Z" fill="none" {...casing} />}
          <path d="M3 7 L13 2 A 11 11 0 0 1 13 12 Z" fill={color} fillOpacity={0.35} stroke={color} strokeWidth={1.5} />
          {casing && <circle cx="3.5" cy="7" r="2.25" fill="none" {...casing} />}
          <circle cx="3.5" cy="7" r="2.25" fill={color} stroke={color} strokeWidth={1} />
        </g>
      )}
    </svg>
  );
}
